import React, {Component} from 'react';
import {Footer, NavBar, Session,BonificacionesModal, NotificationsModal } from "../../components";
import {VIEW_NAME, config, SERVICE_API, DISPATCH_ID, SERVICE_RESPONSE} from "../../libs/utils/Const";
import {connect} from 'react-redux';
import {ApiClient} from "../../libs/apiClient/ApiClient";
import $ from 'jquery';
import CurrencyFormat from 'react-currency-format';
import moment from 'moment';
import {CSVLink, CSVDownload} from "react-csv";
import ExportReportPDFStatusOrder from '../../components/ExportReportPDFStatusOrder';

let apiClient = ApiClient.getInstance();

class OrderStatusView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            listOrderStatus : [],
            order: {
                header: {},
                body: []
            },
            csvData : [],
            fechaInicio: '',
            fechaFinal: '',
            usuario : '',
            neto : 0,
            total : 0,
            cantidad : 0,
            fechaActual : ''
        };
        this.table = null;
    };

    async componentDidMount(){
        let fechaInicio = moment(new Date()).format('YYYY-MM-DD');
        let fechaFinal = moment(new Date()).format('YYYY-MM-DD');
        this.setState({
            fechaInicio,
            fechaFinal
        });
        setTimeout(() => {
            this.cargarDatos();
        }, 2000);
        
        
        // this.table.destroy();
    };

    async cargarDatos (){
        const {enableSpinner} = this.props;
        const {fechaInicio, fechaFinal} = this.state;
        enableSpinner(true);
        let seller = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
        
        let data ={
            usuario : seller.salesPrson || seller.empID,
            fechaInicio : fechaInicio,
            fechaFinal : fechaFinal,
            tipoUsuario: seller.U_FMB_Handel_Perfil
        }
        let newdatas = await apiClient.getOrderStatus(data);
        
        if (newdatas.status === SERVICE_RESPONSE.SUCCESS) {
            let user = localStorage.getItem(config.general.localStorageNamed + 'CurrentUser');
            user = JSON.parse(user) || {}; 
            let total = 0;
            let neto = 0;
            for (let i = 0; i < newdatas.data.list.length; i++) {
                const datos = newdatas.data.list[i];
                total += Number(datos.DocTotal)
                neto += Number(datos.Neto)
            }

            this.setState({
                listOrderStatus : newdatas.data.list,
                CardName : user.CardName,
                usuario : seller.salesPrson,
                neto : neto,
                total : total,
                cantidad : newdatas.data.list.length || 0,
                fechaActual : moment(new Date()).format('YYYY-MM-DD')
            });
    
            this.table = $('#orderStatus').DataTable({
                "paging": false,
                "info": false,
                "searching": false
            });
            enableSpinner(false);
            return;
        }
        
        enableSpinner(false);
    };

    Details = async (valor) => {
        const {notificationReducer: { showAlert }, enableSpinner} = this.props;
        
        enableSpinner(true);
        let responses = await apiClient.getDetailsOrderStatus(valor);
        if (responses.data.list.length > 0 && responses.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                order: responses.data.list,
            });

            $('#detailsOrders').modal('show');
            enableSpinner(false);
            return;
        }
        else{
            this.setState({
                order: [],
            });
            showAlert({ type: 'error', message: 'Los artículos guardados en este carrito ya no son visibles para este cliente',timeOut: 5000 });
            enableSpinner(false);
            return;
        }
    }

    handleInputDateInicio = event =>{
        let fechaInicio = event.nativeEvent.target.value;
        this.setState({
            fechaInicio
        });
    }

    handleInputDateFinal = event =>{
        let fechaFinal = event.nativeEvent.target.value;
        this.setState({
            fechaFinal
        });
    }

    getData = async () =>{        
        this.table.destroy();
        this.cargarDatos();
    }

    download = () => {
        const { enableSpinner, notificationReducer: { showAlert }} = this.props;
        const { listOrderStatus } = this.state;

        // showAlert({ type: 'warning', message: 'Los artículos de bonificacion no se guardan' });
        
        enableSpinner(true);
        let csvData = [];
        if(listOrderStatus.length > 0){
            listOrderStatus.map((data)=>{
                let row ={
                    // '':'',
                    'FECHA EMISIÓN': moment(data.DocDate).format('DD-MM-YYYY'),
                    'PEDIDO' : data.DocNum,
                    'CÓDIGO CLIENTE' : data.CardCode,
                    'CLIENTE' : data.CardName, 
                    'DIRECCIÓN DE ENTREGA' : data.Address2,
                    'ZONA' : data.Zona, 
                    'PESO NETO' : data.Neto ,
                    'PESO EN' : 'KG',
                    'MONEDA' : 'S/',
                    'VALOR' : parseFloat(data.DocTotal).toFixed(2),
                    'FACTURA': data.NumAtCard,
                    'CONDICIÓN': data.PymntGroup,
                    'VALIDACION DE PAGO': data.U_SYP_RICO_HABENTR === 'Y' ? 'Aprobado' : 'Pendiente',
                    // 'CLIENTE': '',
                    // 'NOMBRE': '',
                }
                csvData.push(row);
            });
            // csvData[0].CLIENTE = 'user.CardCode';
            // csvData[0].NOMBRE = 'user.CardName';

            this.setState({
                csvData,
                action : 1
            });
        }
        enableSpinner(false)

    };

    render() {
        const {history} = this.props;
        const {listOrderStatus, order, fechaInicio, fechaFinal, csvData, neto, total, cantidad, fechaActual} = this.state; 

        return (
            <div className="content-fluid marginTable" style={{marginTop: 66}}>
                <Session history={history} view={VIEW_NAME.PROMO_VIEW}/>
                <NavBar/>

                <div className="container mb-4" style={{paddingTop: 60}}>
                    <div className="row">
                        <div className="col">
                            <div className="jumbotron" style={{paddingTop:'10px', paddingBottom:'10px'}}>
                                <h1 className="display-6 text-center">Estado de pedidos</h1>
                            </div>
                        </div>    
                    </div>
                </div> 
                <div className="col-md-11 col-sm-12" style={{marginRight:'auto', marginLeft:'auto'}}>
                    <div className="row text-center" style={{marginBottom: 16, marginTop: 16}}>
                        <div className=" row col-md-4">
                            <h4 className="pr-2">Desde:</h4>
                            <input 
                                id="fechaInicio"
                                type="date" 
                                className="form-control col-md-6" 
                                name="fechauno" 
                                max={fechaActual}
                                value = {fechaInicio}
                                onChange = {(event) => this.handleInputDateInicio(event)}/>
                        </div>
                        <div className="row col-md-4 pb-3">
                            <h4 className="pr-2">Hasta:</h4>
                            <input 
                                id="FechaFin"
                                type="date" 
                                className="form-control col-md-6" 
                                name="fechados" 
                                max={fechaActual}
                                value = {fechaFinal}
                                onChange = {(event) => this.handleInputDateFinal(event)}/>
                        </div>
                        <div className="col-md-2 pb-2">
                            <button
                                onClick={()=>this.getData()}
                                className="btn botonResumen" 
                                style={{
                                    backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                    color: config.navBar.textColorCategorieHover,
                                    fontWeight: "bold",
                                }}>
                                Ver pedidos
                            </button>
                        </div>
                    </div>  

                    <div className="table-responsive" style={{marginBottom: 0, height: 400, maxHeight: 400, overflow: 'auto'}}> 
                        <table id="orderStatus" className="table table-hover scrolltable" style={{marginRight: 0, marginLeft: 0}}>
                            <thead >
                                <tr className="text-light text-center" style={{background: '#2d75bd', borderRadius: '0'}} >
                                {/* <th scope="col">#</th> */}
                                <th scope="col">F. Emisión</th>
                                <th scope="col">Pedido</th>
                                <th scope="col">Cód. Cliente</th>
                                <th scope="col">Cliente</th>
                                <th scope="col">Dirección de entrega</th>
                                <th scope="col">Zona</th>
                                <th scope="col">Peso neto</th>
                                <th scope="col">Valor</th>
                                <th scope="col">FACTURA</th>
                                <th scope="col">Condición</th>
                                <th scope="col" style={{paddingRight: 0, paddingLeft: 0, width: '90px'}}>Validación de pago</th>
                                <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {!!listOrderStatus && listOrderStatus.map((cart, index ) => {
                                    return(
                                        <tr className="text-center">
                                            {/* <th scope="row">{index+1}</th> */}
                                            <td style={{padding: 0}}>{moment(cart.DocDate).format('DD-MM-YYYY')}</td>
                                            <td style={{padding: 0}}>{cart.DocNum}</td>
                                            <td style={{padding: 0}}>{cart.CardCode}</td>
                                            <td style={{padding: 0}}>{cart.CardName}</td>
                                            <td style={{padding: 0}}>{cart.Address2}</td>
                                            <td style={{padding: 0}}>{cart.Zona}</td>
                                            <td style={{padding: 0}}>{cart.Neto + ' KG'}</td>
                                            <td style={{padding: 0}}>
                                            <CurrencyFormat
                                                value={cart.DocTotal}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                decimalScale={2}
                                                prefix={config.general.currency}>
                                            </CurrencyFormat>
                                            </td>
                                            <td style={{padding: 0}}>{cart.NumAtCard}</td>
                                            <td style={{padding: 0}}>{cart.PymntGroup}</td>
                                            <td style={{padding: 0}}>{cart.U_SYP_RICO_HABENTR === 'Y' ? 'Aprobado' : 'Pendiente'}</td>
                                            <td style={{padding: 0}}>
                                                <button
                                                    className="btn btn-sm"
                                                    type="button"
                                                    style={{ backgroundColor: config.navBar.iconBackground, color: config.navBar.iconModal }}
                                                    onClick={() => this.Details(cart.DocEntry)}> 
                                                   Visualizar
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div> 
                    <br></br>
                    <div className="float-center" style={{textAlign:'center'}}> 
                        <label><strong>Total peso neto: </strong>{parseFloat(neto).toFixed(2) + ' KG'}</label>&nbsp;&nbsp;
                        <label><strong>Total: </strong>
                            <CurrencyFormat value={total} displayType={'text'} thousandSeparator={true} fixedDecimalScale={true} decimalScale={2} prefix={config.general.currency}/>
                        </label>&nbsp;&nbsp;
                        <label><strong>Pedidos: </strong>{cantidad}</label>
                    </div>

                    <CSVLink
                        className="btn btn-success float-left"
                        onClick={this.download}
                        style={{
                            color: config.navBar.textColorCategorieHover,
                            fontWeight: "bold",
                        }}
                        data={csvData} filename={"EstadoDePedidos.csv"}>
                            Descargar Excel <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                    </CSVLink>
                    <ExportReportPDFStatusOrder data={listOrderStatus}></ExportReportPDFStatusOrder>
                </div>

                <div class="modal fade bd-example-modal-xl" id="detailsOrders" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header text-light" style={{background: '#2d75bd', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Detalle del pedido</h4>

                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body bg3">
                                {order && order.length > 0 && order.map(item => {
                                    return <div key={item.ItemCode} className="row">
                                        <div className="col-md-3 text-center">
                                            <img className="img-fluid" style={{ backgroundColor: 'white', maxHeight: 130 }}
                                                src={item.PicturName ? (config.BASE_URL + SERVICE_API.getImage + '/' + item.PicturName) : require('../../images/noImage.png')}
                                                alt=""
                                            />
                                        </div>
                                        <div className="col-md-8 table-responsive">
                                            <div className="container p-0">
                                                <div className="row text-left">
                                                    <div className="col-md-12"  style={{borderBottom: '1px solid rgb(124, 124, 125)'}}>
                                                        {item.ItemName}
                                                    </div>
                                                </div>
                                                <div className="row font-weight-bold ">
                                                    <div className="col-md-3 text-center">
                                                        Código
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        Cantidad
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        Precio unitario
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        Precio total
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 text-center">
                                                        {item.ItemCode}
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        {parseInt(item.Quantity)}
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        <CurrencyFormat
                                                            value={Number(item.Price) + Number((item.Price * (18 / 100)))}
                                                            displayType={'text'}
                                                            thousandSeparator={true}
                                                            fixedDecimalScale={true}
                                                            decimalScale={2}
                                                            prefix={config.general.currency}>
                                                        </CurrencyFormat>
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        <CurrencyFormat
                                                            value={Number(item.LineTotal) + Number((item.LineTotal * (18 / 100)))}
                                                            displayType={'text'}
                                                            thousandSeparator={true}
                                                            fixedDecimalScale={true}
                                                            decimalScale={2}
                                                            prefix={config.general.currency}>
                                                        </CurrencyFormat>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        );
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderStatusView);

